import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const defaultTemplate = `
<p><strong>Ref :</strong></p>
<p><strong>Sample No :</strong></p>
<p><strong>Clinical Information :</strong></p>
<p><strong>Macroscopic :</strong></p>
<p><strong>Microscopy :</strong></p>
<p><strong>Impression :</strong></p>
<p><strong>Remarks :</strong></p>
`;

const FnacProfile = ({ profile, handleTestProfileChange }) => {
  return (
    <>
      <h4 style={{ marginTop: "20px", fontWeight: "600" }}>FNAC</h4>
      <CKEditor
        editor={ClassicEditor}
        data={profile?.fnacDescription || defaultTemplate}
        onChange={(event, editor) => {
          const data = editor.getData();
          handleTestProfileChange(
            { target: { value: data } }, 
            "fnacDescription",
            profile._id
          );
        }}
      />
    </>
  );
};

export default FnacProfile;